
<form class="form-vertical" id="editprivcatform" data-hook="editprivcatform">
    <div class="row">
        <div class="form-group col-xs-12 col-md-3">
            <label for="serviceshortcut">Kürzel</label>
            <input class="form-control" type="text" required ng-model="vm.privcatentry.shortcut" id="serviceshortcut">
        </div>
        <div class="form-group col-xs-12 col-md-9">
            <label for="servicename">Bezeichnung der Privatleistungs</label>
            <input class="form-control" type="text" required ng-model="vm.privcatentry.name" id="servicename">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-xs-12 col-md-12">
            <label for="servicedetails">Details</label>
            <textarea class="form-control"
                      ng-model="vm.privcatentry.details" id="servicedetails"></textarea>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-xs-6 col-md-3">
            <label for="serviceprice">Preis</label>
            <input class="form-control" type="number" required
                   ng-change="vm.normPrice()"
                   ng-model="vm.privcatentry.price" id="serviceprice"
                   style="text-align: right"

                   step="0.01" min="0" max="100000">
        </div>
        <div class="form-group col-xs-6 col-md-3">
            <label for="servicetax">Steuersatz (%)</label>
            <input class="form-control" type="number" required ng-model="vm.privcatentry.tax" id="servicetax"
                   style="text-align: right"
                   step="1" min="0" max="100">
        </div>
        <div class="form-group col-xs-12 col-md-6">
            <label for="servicerepeat">Wiederholbarkeit<sprhelp tip="Es können mehrere Einheiten dieser
                   Position auf einer Rechnung vorkommen"></sprhelp></label>
            <div style="padding-bottom: 6px; padding-top: 6px;"><input type="checkbox"  ng-model="vm.privcatentry.repeatable"  id="servicerepeat"
        >&nbsp;Position is wiederholbar</div>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="bva">BVA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bva" id="bva">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="sva">SVA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.sva" id="sva">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="vaeb">VAEB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.vaeb" id="vaeb">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="wgkk">WGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.wgkk" id="wgkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="noegkk">NöGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.noegkk" id="noegkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="bgkk">BGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="bgkk">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="ooegkk">OÖGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.ooegkk" id="ooegkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="sgkk">SGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.sgkk" id="sgkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="stgkk">STGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.stgkk" id="stgkk">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kgkk">KGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kgkk" id="kgkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="tgkk">TGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.tgkk" id="tgkk">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="vgkk">VGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.vgkk" id="vgkk">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="svb">SVB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.svb" id="svb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="bkk-va">BKK-VA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkva" id="bkk-va">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="bkkmondi">BKKMondi Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="bkkmondi">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="bkkwvb">BKK-WVB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkwvb" id="bkkwvb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="bkkzw">BKK-ZW Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkzw" id="bkkzw">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="bkkka">BKK-KA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkka" id="bkkka">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfawien">KFA-Wien Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.wgkk" id="kfawien">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfabaden">KFA-Baden Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfabaden" id="kfabaden">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfalinz">KFA-Linz Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="kfalinz">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfaooegb">KFA-OÖ-GemB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfaooegb" id="kfaooegb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfaooelb">KFA-OÖ-LandB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfaooelb" id="kfaooelb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="ooelku">OÖLehrerKUF Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.ooelku" id="ooelku">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfasteyr">KFA-Steyr Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfasteyr" id="kfasteyr">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfawels">KFA-Wels Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfawels" id="kfawels">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfagraz">KFA-Graz Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfagraz" id="kfagraz">
        </div>
    </div>
     <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfavillach">KFA-Villach Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfavillach" id="kfavillach">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfasalzburg">KFA-Salzburg Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfasalzburg" id="kfasalzburg">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kuftlehrer">KUF-Tirol-Lehrer Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kuftlehrer" id="kuftlehrer">
        </div>
    </div>
      <div class="row">
        <div class="form-group col-xs-12 col-md-4">
            <label for="kuftlb">KUF-Tirol-LandB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kuftlb" id="kuftlb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kufttgb">KUF-Tirol-GemB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kufttgb" id="kufttgb">
        </div>
        <div class="form-group col-xs-12 col-md-4">
            <label for="kfehallein">KFE-Hallein<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>
            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfehallein" id="kfehallein">
        </div>
    </div>
    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">
                    Speichern
                </button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">
                    Abbrechen
                </button>
            </div>
        </div>
    </div>


</form>